(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .controller('ChatMessageDetailController', ChatMessageDetailController);

    ChatMessageDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'DataUtils', 'entity', 'ChatMessage', 'Chat'];

    function ChatMessageDetailController($scope, $rootScope, $stateParams, previousState, DataUtils, entity, ChatMessage, Chat) {
        var vm = this;

        vm.chatMessage = entity;
        vm.previousState = previousState.name;
        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;

        var unsubscribe = $rootScope.$on('bozorakaAdminApp:chatMessageUpdate', function(event, result) {
            vm.chatMessage = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
